export default "__VITE_ASSET__gAtMl1mk__"